import Button from "components/elements/Button/Button";
import { FetchError } from "lib/actions/fetcher";
import AutodeskConnectAction from "./AutodeskConnectAction";

export default function AutodeskRequestError(p: {
  error: unknown;
  workspaceId: number;
  onRetry(): void;
  onReconnected(): void;
}) {
  if (p.error instanceof FetchError && p.error.status === 401) {
    return (
      <div className="space-y-4 text-center text-sm">
        <p>Your Autodesk connection needs renewing.</p>
        <AutodeskConnectAction
          workspaceId={p.workspaceId}
          label="Reconnect"
          onConnected={p.onReconnected}
        />
      </div>
    );
  }

  return (
    <div className="space-y-4 text-center text-sm">
      <p>Autodesk Forma couldn't be reached. Please try again.</p>
      <Button type="button" theme="primary-outline" slim onClick={p.onRetry}>
        Retry
      </Button>
    </div>
  );
}
